import { Injectable, inject } from '@angular/core';
import { RxStomp } from '@stomp/rx-stomp';

import { StompConfig } from './dmb-rx-stomp.config';

@Injectable({ providedIn: 'root' })
export class RxStompService extends RxStomp {
  constructor() {
    super();

    this.configure(inject(StompConfig));
    this.activate();
  }
}
